export function loadFieldOptions(ctx, options) {
    return ctx.dispatch('LOAD_FIELD_OPTIONS', options);
}
